import { notification } from "antd";

const Notification = (status, message) => {
  return notification[status]({
    message: message,
    placement: "bottomLeft",
    duration: 3,
    className: "notification",
  });
};

export default Notification;
